import { AbstractMouseEvent } from './AbstractMouseEvent';
import { Mouse } from './Mouse';
import { CGSMouseEvent } from './MouseEvent';

export class MouseMoveEvent extends AbstractMouseEvent {
  moveEvent: CGSMouseEvent;

  constructor(mouse: Mouse, event: CGSMouseEvent, moveEvent: CGSMouseEvent) {
    super(mouse, event);
    this.moveEvent = moveEvent;
  }
}
